import "./style";
// import './fonts/Inter-SemiBold.woff2'
import App from "./app";

export default App;
